import { Vec2 } from './vec2.js';
/**
 * Circle-to-circle collision detection
 */
export function circleCircle(pos1, radius1, pos2, radius2) {
    const distSq = pos1.distanceToSquared(pos2);
    const radiusSum = radius1 + radius2;
    return distSq <= radiusSum * radiusSum;
}
/**
 * Point inside circle check
 */
export function pointInCircle(point, center, radius) {
    return point.distanceToSquared(center) <= radius * radius;
}
/**
 * Line segment to circle collision
 * Returns the closest point on the line to the circle center if colliding
 */
export function lineCircle(lineStart, lineEnd, circleCenter, circleRadius) {
    const line = lineEnd.sub(lineStart);
    const toCircle = circleCenter.sub(lineStart);
    const lineLen = line.length();
    if (lineLen === 0) {
        const hit = pointInCircle(lineStart, circleCenter, circleRadius);
        return { hit, point: hit ? lineStart : null };
    }
    const lineUnit = line.scale(1 / lineLen);
    const proj = toCircle.dot(lineUnit);
    // Clamp to line segment
    const t = Math.max(0, Math.min(lineLen, proj));
    const closest = lineStart.add(lineUnit.scale(t));
    const distSq = closest.distanceToSquared(circleCenter);
    const hit = distSq <= circleRadius * circleRadius;
    return { hit, point: hit ? closest : null };
}
/**
 * Point inside rectangle check (axis-aligned)
 */
export function pointInRect(point, rectPos, rectWidth, rectHeight) {
    return (point.x >= rectPos.x &&
        point.x <= rectPos.x + rectWidth &&
        point.y >= rectPos.y &&
        point.y <= rectPos.y + rectHeight);
}
/**
 * Circle to rectangle collision (axis-aligned)
 */
export function circleRect(circleCenter, circleRadius, rectPos, rectWidth, rectHeight) {
    // Find closest point on rectangle to circle center
    const closestX = Math.max(rectPos.x, Math.min(circleCenter.x, rectPos.x + rectWidth));
    const closestY = Math.max(rectPos.y, Math.min(circleCenter.y, rectPos.y + rectHeight));
    const closest = new Vec2(closestX, closestY);
    return closest.distanceToSquared(circleCenter) <= circleRadius * circleRadius;
}
/**
 * Rectangle to rectangle collision (axis-aligned)
 */
export function rectRect(pos1, width1, height1, pos2, width2, height2) {
    return (pos1.x < pos2.x + width2 &&
        pos1.x + width1 > pos2.x &&
        pos1.y < pos2.y + height2 &&
        pos1.y + height1 > pos2.y);
}
/**
 * Wrap position around arena bounds (toroidal wrapping)
 */
export function wrapPosition(pos, width, height) {
    let x = pos.x;
    let y = pos.y;
    if (x < 0)
        x += width;
    else if (x >= width)
        x -= width;
    if (y < 0)
        y += height;
    else if (y >= height)
        y -= height;
    return new Vec2(x, y);
}
/**
 * Clamp position inside arena bounds
 */
export function clampPosition(pos, width, height, margin = 0) {
    return new Vec2(Math.max(margin, Math.min(width - margin, pos.x)), Math.max(margin, Math.min(height - margin, pos.y)));
}
//# sourceMappingURL=collision.js.map